import {GetHeaderBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/shared/v1/target_group.types';
import {COLORS, FONT_SIZES, mediaDesktopAndUp} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {Link} from '../../../features/Link/Link';
import {
  useSelectedTargetGroup,
  useUpdateTargetGroup,
} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useTrackHeaderOriginClick} from '../hooks/useOriginClickTrackingFunction';

type Props = GetHeaderBulkResponse['genderSwitch'] & {
  className?: string;
};
export const GenderSwitchView: React.FC<Props> = ({
  targetGroups,
  recommendedTargetGroup,
  className,
}) => {
  useUpdateTargetGroup(recommendedTargetGroup);

  const {targetGroup, switchTargetGroup} = useSelectedTargetGroup();
  const activeTargetGroup = recommendedTargetGroup ?? targetGroup;
  const trackOriginClick = useTrackHeaderOriginClick();

  const handleSwitchTargetGroup = (targetGroup: TargetGroup) => () => {
    switchTargetGroup(targetGroup);
    trackOriginClick();
  };

  if (!targetGroups.targetGroups) {
    return null;
  }

  return (
    <GenderSwitchWrapper data-testid="genderSwitch" className={className}>
      {targetGroups.targetGroups.map(group => {
        const isActive = group.targetGroup === activeTargetGroup;
        return (
          <GenderSwitchStyled
            key={group.targetGroup}
            data-testid={`genderSwitch-${group.targetGroup}`}
            label={group.label}
            linkTarget={group.path}
            data-active={isActive}
            onClick={handleSwitchTargetGroup(group.targetGroup)}
          />
        );
      })}
    </GenderSwitchWrapper>
  );
};

const GenderSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: -8px;

  @media ${mediaDesktopAndUp} {
    margin-left: -15px;
  }
`;

const GenderSwitchStyled = styled(Link)`
  position: relative;
  font-size: ${FONT_SIZES.px14};
  color: ${COLORS.Grey1};
  transition: color 0.5s;
  padding: 0 8px;
  height: 100%;
  line-height: 64px;
  @media ${mediaDesktopAndUp} {
    padding: 0 17px;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 24px;
    height: 2px;
    background: ${COLORS.Black};
    transform: scale(0);
    transition: transform 0.5s ease;
  }

  &[data-active='true'] {
    color: ${COLORS.Black};
    &::after {
      transform: scale(1);
    }
  }

  &:hover {
    color: ${COLORS.Black};
  }
`;
